import { Routes } from "@angular/router";

import { isExternalAppType, isInternalAppType } from "@azm/core/enums/app-types";
import {
	hasSsoScratch,
	SSO_BUSINESS_ACCOUNTS_KEY,
	SSO_GOVERNMENT_ACCOUNTS_KEY,
} from "@azm/features/auth/utilities/sso-scratch-storage";
import { environment } from "@azm/environments/environment";

const isExternalApp = () => isExternalAppType(environment.defaultAppType);

export const authRoutes: Routes = [
	{
		path: "",
		redirectTo: "login",
		pathMatch: "full",
	},
	{
		path: "login",
		title: "auth.login.title",
		children: [
			{
				path: "",
				canMatch: [isExternalApp],
				loadComponent: () => import("./pages/external/login/login.component").then((c) => c.Login),
			},
			{
				path: "",
				canMatch: [() => isInternalAppType(environment.defaultAppType)],
				loadComponent: () => import("./pages/internal/login/login.component").then((c) => c.Login),
			},
		],
	},
	{
		path: "register",
		children: [
			{
				path: "business",
				children: [
					{
						path: "",
						pathMatch: "full",
						title: "auth.register.business.title",
						canMatch: [() => isExternalApp() && hasSsoScratch(SSO_BUSINESS_ACCOUNTS_KEY)],
						loadComponent: () => import("./pages/external/register/business/business.component").then((c) => c.Business),
					},
					{
						path: "",
						pathMatch: "full",
						redirectTo: "/auth/login",
					},
				],
			},
			{
				path: "government",
				children: [
					{
						path: "",
						pathMatch: "full",
						title: "auth.register.government.title",
						canMatch: [() => isExternalApp() && hasSsoScratch(SSO_GOVERNMENT_ACCOUNTS_KEY)],
						loadComponent: () => import("./pages/external/register/government/government.component").then((c) => c.Government),
					},
					{
						path: "",
						pathMatch: "full",
						redirectTo: "/auth/login",
					},
					{
						path: "application-details/:id",
						loadComponent: () =>
							import("@azm/features/auth/pages/external/registration-application-details").then(
								(c) => c.RegistrationApplicationDetails,
							),
					},
				],
			},
		],
	},
];
